import _ from "lodash";

export const removeUnderScore = (data: string): string => {
  return _.capitalize(data.split("_").join(" "));
};
export const removeUnderScoreWithUpperCase = (data: string): string => {
  return _.upperCase(data.split("_").join(" "));
};
